var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-node',{attrs:{"data":_vm.treeData}})
}
var staticRenderFns = []

export { render, staticRenderFns }